// Mock data for Elite Internacional Sport Agency SL

export const players = [
  {
    id: 1,
    name: "Juan Berrocal",
    position: "Defensa",
    age: 26,
    club: "Getafe CF",
    nationality: "España",
    division: "1ª División",
    image: "/images/players/juan-berrocal-new.jpg",
    career: "Defensa central con experiencia internacional. Sólido en el juego aéreo, gran salida de balón y capacidad de liderazgo en la zaga."
  },
  {
    id: 2,
    name: "Pejiño",
    position: "Delantero",
    age: 30,
    club: "SD Eibar",
    nationality: "España",
    division: "2ª División",
    image: "/images/players/pejino-new.jpg",
    career: "Delantero experimentado en Segunda División. Gran visión de juego y capacidad goleadora. Jugador desequilibrante."
  },
  {
    id: 3,
    name: "Moi Delgado",
    position: "Defensa",
    age: 31,
    club: "-",
    nationality: "España",
    division: "-",
    image: "/images/players/moi-delgado.jpg",
    career: "Lateral izquierdo con gran experiencia. Recorrido ofensivo y solidez defensiva. Liderazgo en Primera RFEF."
  },
  {
    id: 4,
    name: "Raúl Hernández",
    position: "Delantero",
    age: 31,
    club: "Rayo Majadahonda CF",
    nationality: "España",
    division: "1ª RFEF",
    image: "/images/players/raul-hernandez-new.jpg",
    career: "Delantero veterano con gran experiencia. Olfato goleador y capacidad de asociación en ataque."
  },
  {
    id: 5,
    name: "Ángel de la Calzada",
    position: "Portero",
    age: 32,
    club: "CD Cieza",
    nationality: "España",
    division: "2ª RFEF",
    image: "/images/players/angel-calzada-new.jpg",
    career: "Portero experimentado. Seguridad bajo palos, buen juego con los pies y liderazgo desde la portería."
  },
  {
    id: 6,
    name: "Charaf Taoualy",
    position: "Centrocampista",
    age: 26,
    club: "UCAM Murcia CF",
    nationality: "Marruecos",
    division: "2ª RFEF",
    image: "/images/players/charaf-taoualy-new.jpg",
    career: "Centrocampista con gran técnica. Distribución de juego, visión y llegada al área rival."
  },
  {
    id: 7,
    name: "Álvaro Telis",
    position: "Defensa",
    age: 28,
    club: "UD Sanse",
    nationality: "España",
    division: "2ª RFEF",
    image: "/images/players/alvaro-telis-new.jpg",
    career: "Defensa central con experiencia en Segunda RFEF. Contundencia defensiva y salida de balón."
  },
  {
    id: 8,
    name: "Juan Duran",
    position: "Defensa",
    age: 24,
    club: "Rayo Majadahonda CF",
    nationality: "España",
    division: "1ª RFEF",
    image: "/images/players/juan-duran-new.jpg",
    career: "Defensa joven con gran proyección. Velocidad, anticipación y buenos fundamentos técnicos."
  },
  {
    id: 9,
    name: "Mario González",
    position: "Centrocampista",
    age: 27,
    club: "UB Conquense",
    nationality: "España",
    division: "2ª RFEF",
    image: "/images/players/mario-gonzalez-new.jpg",
    career: "Centrocampista box-to-box. Gran despliegue físico y capacidad de llegada desde segunda línea."
  },
  {
    id: 10,
    name: "David Santisteban",
    position: "Delantero",
    age: 24,
    club: "-",
    nationality: "España",
    division: "2ª RFEF",
    image: "/images/players/david-santisteban.jpg",
    career: "Delantero rápido y desequilibrante. Capacidad de desborde por banda y llegada al gol."
  },
  {
    id: 12,
    name: "Sebas Holgado",
    position: "Defensa",
    age: 22,
    club: "Yeclano Deportivo",
    nationality: "España",
    division: "2ª RFEF",
    image: "/images/players/sebas-holgado-new.jpg",
    career: "Joven defensa con gran proyección. Versatilidad en diferentes posiciones defensivas."
  },
  {
    id: 13,
    name: "Álvaro Domínguez",
    position: "Defensa",
    age: 21,
    club: "CD Coria",
    nationality: "España",
    division: "1ª RFEF",
    image: "/images/players/alvaro-dominguez-new.jpg",
    career: "Defensa joven con gran potencial. Capacidad de aprendizaje y proyección profesional."
  },
  {
    id: 15,
    name: "Alfonso Liceras",
    position: "Portero",
    age: 22,
    club: "CD Extremadura",
    nationality: "España",
    division: "1ª RFEF",
    image: "/images/players/alfonso-liceras-new.jpg",
    career: "Portero joven con buenos reflejos. Agilidad, colocación y seguridad bajo palos."
  },
  {
    id: 16,
    name: "Álvaro Díaz",
    position: "Defensa",
    age: 21,
    club: "CD Estepona",
    nationality: "España",
    division: "2ª RFEF",
    image: "/images/players/alvaro-diaz-new.jpg",
    career: "Defensa joven con mucha proyección. Velocidad y agresividad defensiva."
  },
  {
    id: 17,
    name: "Raúl Navas",
    position: "Defensa",
    age: 38,
    club: "Atlético Central",
    nationality: "España",
    division: "2ª RFEF",
    image: "/images/players/raul-navas-new.jpg",
    career: "Veterano defensa con gran experiencia. Liderazgo dentro y fuera del campo."
  },
  {
    id: 18,
    name: "Diego Domínguez",
    position: "Delantero",
    age: 27,
    club: "RB Linense",
    nationality: "España",
    division: "3ª RFEF",
    image: "/images/players/diego-dominguez.jpg",
    career: "Delantero goleador en Tercera RFEF. Definición y juego de espaldas."
  },
  {
    id: 20,
    name: "Izan Segura",
    position: "Centrocampista",
    age: 20,
    club: "Real Murcia B",
    nationality: "España",
    division: "3ª RFEF",
    image: "/images/players/izan-segura.jpg",
    career: "Centrocampista joven del filial del Real Murcia. Talento en desarrollo."
  },
  {
    id: 21,
    name: "Manu Romero",
    position: "Centrocampista",
    age: 19,
    club: "Sevilla C",
    nationality: "España",
    division: "3ª RFEF",
    image: "/images/players/manu-romero.jpg",
    career: "Centrocampista del Sevilla C. Talento, visión de juego y capacidad técnica."
  },
  {
    id: 23,
    name: "Ismael Segura",
    position: "Delantero",
    age: 18,
    club: "Real Murcia Juvenil",
    nationality: "España",
    division: "Cantera",
    image: "/images/players/ismael-segura.jpg",
    career: "Joven promesa de la cantera del Real Murcia. Velocidad, regate y definición."
  },
  {
    id: 24,
    name: "Adri Benítez",
    position: "Centrocampista",
    age: 15,
    club: "Cádiz CF Cadete",
    nationality: "España",
    division: "Cantera",
    image: "/images/players/adri-benitez.jpg",
    career: "Centrocampista juvenil del Cádiz CF. Gran técnica individual y visión de futuro."
  },
  {
    id: 25,
    name: "Alberto Moya",
    position: "Delantero",
    age: 22,
    club: "UD Tomares",
    nationality: "España",
    division: "Cantera",
    image: "/images/players/alberto-moya.jpg",
    career: "Delantero joven con instinto goleador. Promesa del fútbol base."
  },
  {
    id: 26,
    name: "Luis Ortega",
    position: "Defensa",
    age: 18,
    club: "Xerez DFC B",
    nationality: "España",
    division: "Cantera",
    image: "/images/players/luis-ortega.jpg",
    career: "Defensa del filial del Xerez. Anticipación y juego posicional destacado."
  },
  {
    id: 27,
    name: "Carlos Toscano",
    position: "Portero",
    age: 17,
    club: "Sevilla FC Juvenil",
    nationality: "España",
    division: "Cantera",
    image: "/images/players/carlos-toscano.jpg",
    career: "Portero de la cantera sevillista. Reflejos, colocación y gran proyección."
  },
  {
    id: 28,
    name: "Sergio García",
    position: "Centrocampista",
    age: 17,
    club: "Rayo Vallecano Juvenil",
    nationality: "España",
    division: "Cantera",
    image: "/images/players/sergio-garcia.jpg",
    career: "Centrocampista juvenil del Rayo Vallecano. Intensidad y despliegue físico."
  },
  {
    id: 29,
    name: "Adri Hernández",
    position: "Defensa",
    age: 16,
    club: "Sevilla FC Juvenil",
    nationality: "España",
    division: "Cantera",
    image: "/images/players/adri-hernandez.jpg",
    career: "Defensa de la cantera sevillista. Proyección, sacrificio y fundamentos sólidos."
  },
  {
    id: 30,
    name: "Alan Plata",
    position: "Defensa",
    age: 18,
    club: "Club Necaxa",
    nationality: "México",
    division: "Cantera",
    image: "/images/players/alan-plata.jpg",
    career: "Defensa mexicano en Club Necaxa. Experiencia internacional y gran proyección."
  },
  {
    id: 31,
    name: "Jesús Suárez",
    position: "Defensa",
    age: 17,
    club: "Sevilla FC Juvenil",
    nationality: "España",
    division: "Cantera",
    image: "/images/players/jesus-suarez.jpg",
    career: "Defensa juvenil del Sevilla FC. Fortaleza física, anticipación y mentalidad ganadora."
  },
  {
    id: 32,
    name: "Alejandro Llorens",
    position: "Defensa",
    age: 18,
    club: "CE Singuerlin",
    nationality: "España",
    division: "Cantera",
    image: "/images/players/alejandro-llorens.jpg",
    career: "Defensa joven con gran potencial. Solidez defensiva y capacidad de proyección."
  },
  {
    id: 33,
    name: "Álex Macias",
    position: "Defensa",
    age: 24,
    club: "CD Extremadura",
    nationality: "España",
    division: "1ª RFEF",
    image: "/images/players/alex-macias.jpg",
    career: "Lateral izquierdo con gran recorrido y capacidad ofensiva. Intensidad, sacrificio y mentalidad ganadora."
  }
];

// News data
export const news = [
  {
    id: 1,
    title: "Ramón García ficha por el Dos Hermanas CF",
    slug: "ramon-garcia-ficha-dos-hermanas-cf",
    date: "2026-01-07",
    category: "Fichaje",
    image: "/images/news/noticia1.jpg",
    summary: "Nuestro representado Ramón García da un paso importante en su carrera al unirse al Dos Hermanas CF, un club con gran proyección en la categoría.",
    content: `Elite Internacional Sport Agency se complace en anunciar que Ramón García, defensa polivalente de 25 años, se incorpora al Dos Hermanas CF para afrontar la segunda mitad de la temporada.

Ramón llega procedente del CF Conil y aporta su experiencia en Tercera RFEF, donde ha demostrado ser un jugador versátil capaz de actuar tanto en el centro de la defensa como en la banda. Su solidez defensiva y capacidad de lectura del juego lo convierten en un refuerzo clave para el equipo.

Desde Elite Internacional hemos trabajado intensamente para encontrar el proyecto ideal que se ajuste a las características y ambiciones de Ramón. El Dos Hermanas CF representa una oportunidad perfecta para continuar su desarrollo profesional en un entorno competitivo y con una estructura sólida.

"Estamos muy contentos por Ramón. Es un jugador con mucho potencial y estamos seguros de que demostrará su valía en esta nueva etapa," declaró nuestro equipo de representación.

Le deseamos mucho éxito en esta nueva aventura y estaremos apoyándole en cada paso del camino.`
  },
  {
    id: 2,
    title: "Álvaro Díaz evoluciona favorablemente tras su intervención",
    slug: "alvaro-diaz-evolucion-favorable-intervencion",
    date: "2026-01-10",
    category: "Recuperación",
    image: "/images/news/noticia2.jpg",
    summary: "Nuestro jugador Álvaro Díaz del CD Estepona ha sido intervenido con éxito. El proceso de recuperación avanza según lo previsto.",
    content: `Desde Elite Internacional Sport Agency queremos informar que Álvaro Díaz, defensa del CD Estepona, ha sido sometido a una intervención médica que ha resultado completamente exitosa.

La operación, programada tras una exhaustiva evaluación por parte del cuerpo médico, transcurrió sin complicaciones. Álvaro, de 20 años, se encuentra en perfecto estado y ya ha comenzado su proceso de recuperación con el apoyo de fisioterapeutas especializados y el equipo técnico del club.

Álvaro es uno de nuestros jóvenes talentos más prometedores, y su mentalidad ganadora y profesionalidad nos dan la seguridad de que afrontará esta etapa con la máxima dedicación. Durante este período, estará trabajando intensamente para volver a los terrenos de juego más fuerte que nunca.

"La salud de nuestros jugadores es lo primero. Estamos en contacto constante con Álvaro y su entorno para asegurar que tiene todo lo necesario en este proceso de recuperación," manifestó nuestro equipo.

Todo el staff de Elite Internacional está con Álvaro en este camino. ¡Mucho ánimo y adelante!`
  },
  {
    id: 3,
    title: "Izan Segura intervenido con éxito de su rodilla",
    slug: "izan-segura-intervencion-exitosa-rodilla",
    date: "2026-01-20",
    category: "Recuperación",
    image: "/images/news/noticia3.jpg",
    summary: "Izan Segura del Real Murcia B ha sido operado satisfactoriamente de su lesión en la rodilla. Comienza su proceso de recuperación con optimismo.",
    content: `Elite Internacional Sport Agency informa que nuestro representado Izan Segura, centrocampista del Real Murcia B, ha sido intervenido quirúrgicamente de su rodilla con resultados totalmente satisfactorios.

La intervención, realizada por un equipo médico de primer nivel, se desarrolló conforme a lo planificado. Todo salió según lo previsto y ahora Izan inicia el camino de recuperación con la mentalidad positiva y la determinación que siempre le han caracterizado.

Izan, de 20 años, es un talento emergente del fútbol base murciano con un gran futuro por delante. Su juventud y compromiso profesional son factores clave que favorecerán una recuperación óptima. El proceso requerirá tiempo, paciencia y trabajo constante, pero estamos convencidos de que volverá con la misma intensidad que ha demostrado desde sus inicios.

"Izan es un jugador ejemplar dentro y fuera del campo. Cuenta con todo nuestro apoyo en cada paso de este proceso. La calma, el trabajo y la confianza serán sus mejores aliados," expresó nuestro departamento de seguimiento.

Desde Elite Internacional estaremos a su lado en todo momento, coordinando con el club y los especialistas médicos para garantizar la mejor atención posible. Estamos contigo, Izan. ¡Mucho ánimo y adelante!`
  },
  {
    id: 4,
    title: "José Pedraza se incorpora al Sevilla Atlético",
    slug: "jose-pedraza-sevilla-atletico-fichaje",
    date: "2026-01-24",
    category: "Fichaje",
    image: "/images/news/noticia4.jpg",
    summary: "Elite Internacional gestiona el fichaje de José Pedraza por el Sevilla Atlético. Un paso importante en la carrera de este joven talento.",
    content: `Elite Internacional Sport Agency se enorgullece de anunciar que José Pedraza es nuevo jugador del Sevilla Atlético, filial del Sevilla FC que compite en la Primera Federación.

José Pedraza, joven futbolista con gran proyección, se incorpora a uno de los equipos filiales más prestigiosos del fútbol español. El Sevilla Atlético, conocido por su cantera de calidad y por ser trampolín hacia el primer equipo, representa una oportunidad única para continuar su desarrollo profesional en un entorno competitivo y exigente.

Desde Elite Internacional hemos trabajado estrechamente con todas las partes involucradas para hacer posible esta operación. La llegada de José al Sevilla Atlético es fruto de un proceso de negociación meticuloso que garantiza las mejores condiciones para su crecimiento deportivo.

"Estamos muy satisfechos con este fichaje. José tiene el talento y la mentalidad necesarios para triunfar en un club con la historia y exigencia del Sevilla FC. Confiamos plenamente en que aprovechará esta oportunidad al máximo," señaló nuestro equipo directivo.

José se unirá de inmediato a los entrenamientos del Sevilla Atlético y estará disponible para los próximos compromisos del equipo. Le deseamos el mayor de los éxitos en esta nueva etapa de su carrera.`
  },
  {
    id: 5,
    title: "Marcos Alconchel ya es nuevo guardameta del Xerez CD",
    slug: "marcos-alconchel-nuevo-portero-xerez-cd",
    date: "2026-01-26",
    category: "Fichaje",
    image: "/images/news/noticia5.jpg",
    summary: "Elite Internacional cierra la incorporación de Marcos Alconchel al Xerez CD. El portero llega para reforzar la portería del conjunto jerezano.",
    content: `Elite Internacional Sport Agency confirma que Marcos Alconchel es oficialmente nuevo jugador del Xerez Club Deportivo, donde ejercerá como guardameta del primer equipo.

Marcos Alconchel llega al Xerez CD con la responsabilidad de aportar seguridad y experiencia bajo los tres palos. Su incorporación refuerza significativamente la portería del conjunto jerezano, que busca consolidarse en Segunda RFEF con aspiraciones de ascenso.

El portero destaca por sus reflejos, su buen juego con los pies y su capacidad de liderazgo desde la portería. Estas cualidades fueron determinantes para que el Xerez CD apostara por él como pieza clave de su proyecto deportivo.

"Marcos es un portero completo que se adapta perfectamente a lo que busca el Xerez CD. Estamos convencidos de que será un pilar fundamental para el equipo en la segunda vuelta de la temporada," afirmó nuestro departamento de contratación.

Desde Elite Internacional hemos facilitado todas las gestiones necesarias para que Marcos pueda incorporarse de inmediato a la dinámica del equipo. Le deseamos el mayor de los éxitos defendiendo la portería del Xerez CD y estamos seguros de que dejará su huella en el club.

¡Bienvenido, Marcos, y mucha suerte en esta nueva aventura!`
  },
  {
    id: 6,
    title: "Mario González alcanza los 100 partidos con el UD Sanse",
    slug: "mario-gonzalez-100-partidos-ud-sanse",
    date: "2026-02-03",
    category: "Hito Deportivo",
    image: "/images/news/noticia6.jpg",
    summary: "Mario González, representado por Elite Internacional, celebra un hito histórico al alcanzar los 100 partidos oficiales con el UD Sanse.",
    content: `Elite Internacional Sport Agency felicita calurosamente a Mario González por alcanzar un hito extraordinario en su carrera: ¡100 partidos oficiales con el UD Sanse!

Este logro es mucho más que una cifra. Representa la constancia, el compromiso y la profesionalidad de un jugador que ha dejado su corazón en cada minuto disputado defendiendo el escudo del Sanse. Mario, de 27 años, se ha convertido en uno de los pilares fundamentales del equipo en Segunda RFEF, destacando por su despliegue físico, llegada desde segunda línea y capacidad de organización en el centro del campo.

Durante estos 100 encuentros, Mario ha demostrado ser un centrocampista box-to-box completo, contribuyendo tanto en labores defensivas como ofensivas. Su entrega y mentalidad ganadora lo han convertido en un referente dentro del vestuario y un ejemplo para las nuevas generaciones del club.

"Mario es el tipo de jugador que todo entrenador desea tener. Profesional, comprometido y con una ética de trabajo admirable. Estos 100 partidos son un reflejo de su dedicación y amor por el fútbol," destacó nuestro equipo de Elite Internacional.

Desde la agencia queremos agradecerle por su confianza y felicitarle por este merecido reconocimiento. ¡Enhorabuena, Mario! Que vengan muchos partidos más defendiendo tu escudo con la misma pasión.`
  },
  {
    id: 7,
    title: "Raúl Hernández ya es jugador del Ourense CF",
    slug: "raul-hernandez-fichaje-ourense-cf",
    date: "2026-02-04",
    category: "Fichaje",
    image: "/images/news/noticia7.jpg",
    summary: "Raúl Hernández se incorpora al Ourense CF de Primera RFEF. Un nuevo reto para el delantero veterano representado por Elite Internacional.",
    content: `Elite Internacional Sport Agency anuncia con satisfacción que Raúl Hernández es nuevo jugador del Ourense CF, que compite en la exigente Primera RFEF.

Raúl Hernández, delantero experimentado de 31 años, llega al conjunto gallego para aportar su olfato goleador y veteranía en una categoría tan competitiva como la Primera RFEF. Procedente del Real Avilés, Raúl se incorpora al Ourense CF con la responsabilidad de reforzar la delantera y contribuir con goles y asistencias en la lucha por los objetivos del equipo.

El fichaje representa un paso importante en la carrera de Raúl, quien tendrá la oportunidad de demostrar su calidad en una categoría superior y ante rivales de mayor nivel. Su capacidad de asociación, juego de espaldas y definición serán claves para el proyecto del Ourense CF.

"Raúl es un delantero con una trayectoria destacada y muchas ganas de seguir demostrando su valía. El Ourense CF es el lugar perfecto para que continúe creciendo y aportando su experiencia al equipo," señaló nuestro departamento deportivo.

Desde Elite Internacional hemos trabajado para que Raúl encuentre el proyecto ideal donde seguir desarrollándose profesionalmente. Le deseamos el mayor de los éxitos en esta nueva etapa y estamos convencidos de que será un jugador determinante para el Ourense CF.

¡Mucha suerte, Raúl!`
  },
  {
    id: 8,
    title: "Juan Berrocal listo para el inicio de la MLS con el Atlanta United",
    slug: "juan-berrocal-listo-inicio-mls-atlanta-united",
    date: "2026-02-12",
    category: "Actualidad",
    image: "/images/news/noticia8.jpg",
    summary: "Juan Berrocal posa con la nueva equipación del Atlanta United FC. El equipo se prepara para el inicio de la MLS el 21 de febrero ante Cincinnati.",
    content: `Elite Internacional Sport Agency comparte con orgullo las imágenes de Juan Berrocal luciendo la nueva equipación del Atlanta United FC de cara al inicio de la temporada 2026 de la Major League Soccer (MLS).

Juan Berrocal, defensa central español de 26 años, afronta su primera temporada completa con el Atlanta United tras su fichaje el año pasado. El jugador se encuentra en plena forma y listo para afrontar los desafíos de una de las ligas más competitivas y físicamente exigentes del mundo.

El Atlanta United debutará en la MLS 2026 el próximo 21 de febrero en un partido de alto voltaje ante el FC Cincinnati, encuentro que se disputará a domicilio. Berrocal, que ha destacado por su solidez en el juego aéreo y su capacidad de salida de balón, será una pieza clave en el esquema defensivo del equipo dirigido por el cuerpo técnico del club.

Durante la pretemporada, Juan ha trabajado intensamente para adaptarse a las exigencias tácticas y físicas de la MLS. Su profesionalidad y compromiso le han convertido en un referente dentro del vestuario del Atlanta United.

"Juan está en un momento excelente de su carrera. Ver cómo se ha adaptado a la MLS y cómo el club confía en él nos llena de satisfacción. Estamos seguros de que será una temporada importante para él," manifestó el equipo de Elite Internacional.

Desde la agencia seguiremos de cerca su trayectoria en Estados Unidos y estaremos apoyándole en cada partido. ¡Adelante, Juan! Que sea una gran temporada.`
  },
  {
    id: 9,
    title: "Elite Internacional visita a Juan Berrocal en Atlanta",
    slug: "elite-visita-juan-berrocal-atlanta",
    date: "2026-03-15",
    category: "Actualidad",
    image: "/images/news/visita-atlanta.jpg",
    summary: "Desde Elite Internacional nos gusta estar cerca de los nuestros, incluso cuando están lejos de casa. Visitamos a Juan Berrocal y su familia en Atlanta.",
    content: `En Elite Internacional Sport Agency creemos que la cercanía con nuestros jugadores va más allá de los contratos y las negociaciones. Por eso, nos desplazamos hasta Atlanta para visitar a Juan Berrocal y su familia.

Durante nuestra estancia, pudimos comprobar de primera mano cómo Juan se ha adaptado a la vida en Estados Unidos. Su profesionalidad y dedicación siguen siendo ejemplares, y su integración en el Atlanta United ha sido excelente.

Estos encuentros son fundamentales para nosotros. Nos permiten conocer las necesidades reales de nuestros jugadores, apoyarles en su día a día y reforzar los lazos que nos unen. Porque en Elite Internacional, la familia siempre es lo primero.

Gracias, Juan, por recibirnos con los brazos abiertos. Seguiremos apoyándote desde la distancia y celebrando cada uno de tus éxitos. ¡Adelante, campeón!`
  },
  {
    id: 10,
    title: "Juan Duran y Álvaro Telis, campeones de 2ª RFEF",
    slug: "juan-duran-alvaro-telis-campeones-2rfef",
    date: "2026-05-04",
    category: "Logro",
    image: "/images/news/campeones-2rfef.jpg",
    summary: "Nuestros jugadores Juan Duran y Álvaro Telis se proclaman campeones de 2ª RFEF con el Rayo Majadahonda y ascienden a 1ª RFEF.",
    content: `¡Enhorabuena a Juan Duran y Álvaro Telis! Nuestros representados se han proclamado campeones de Segunda RFEF con el Rayo Majadahonda CF, logrando el ansiado ascenso a Primera RFEF.

Una temporada de trabajo, sacrificio y constancia que culmina con el mejor premio posible: levantar el trofeo de campeones y dar el salto de categoría. Juan y Álvaro han sido piezas fundamentales en el esquema defensivo del equipo, demostrando su calidad y compromiso partido tras partido.

Desde Elite Internacional estamos tremendamente orgullosos de estos dos guerreros. Ver cómo crecen nuestros jugadores y alcanzan sus objetivos es la mayor satisfacción que podemos tener como agencia.

¡Felicidades, campeones! El próximo año os esperan nuevos retos en Primera RFEF, y estamos seguros de que seguiréis brillando. ¡A por todas!`
  },
  {
    id: 11,
    title: "Sebas Holgado ficha por el Yeclano Deportivo",
    slug: "sebas-holgado-ficha-yeclano-deportivo",
    date: "2026-06-03",
    category: "Fichaje",
    image: "/images/news/sebas-yeclano.jpg",
    summary: "Sebas Holgado se incorpora a las filas del Yeclano Deportivo en 2ª RFEF para seguir creciendo y darlo todo por el escudo.",
    content: `Elite Internacional Sport Agency comunica que Sebas Holgado es nuevo jugador del Yeclano Deportivo, equipo que compite en Segunda RFEF.

Sebas, joven defensa de gran proyección, llega al conjunto murciano con muchas ganas de demostrar su valía y seguir creciendo como futbolista. Su versatilidad en diferentes posiciones defensivas y su mentalidad ganadora serán activos muy valiosos para el equipo.

El Yeclano Deportivo es el destino perfecto para que Sebas continúe su desarrollo profesional en un entorno competitivo y con una afición que vive el fútbol con pasión. Estamos convencidos de que dejará huella en el club.

"Sebas tiene todas las cualidades para triunfar. Es joven, ambicioso y trabaja duro cada día. El Yeclano es una gran oportunidad para él," comentó nuestro equipo de representación.

¡Mucha suerte en esta nueva aventura, Sebas! Estaremos contigo en cada paso.`
  },
  {
    id: 12,
    title: "Juan Duran renueva con el Rayo Majadahonda CF",
    slug: "juan-duran-renueva-rayo-majadahonda",
    date: "2026-06-03",
    category: "Renovación",
    image: "/images/news/juan-duran-renueva.jpg",
    summary: "Juan Duran renueva con el Rayo Majadahonda CF para disputar la temporada 26/27 en Primera RFEF. Elite impulsa y hace crecer a sus jugadores.",
    content: `Elite Internacional Sport Agency anuncia con orgullo la renovación de Juan Duran con el Rayo Majadahonda CF para afrontar la temporada 2026/27 en Primera RFEF.

Juan Duran, tras ser pieza clave en el ascenso del equipo, continuará defendiendo el escudo del Rayo Majadahonda en la categoría de bronce del fútbol español. Una muestra de confianza mutua entre el jugador y el club.

Este tipo de noticias reflejan la filosofía de Elite Internacional: apostar por el crecimiento de nuestros jugadores y acompañarles en cada paso de su carrera. Juan llegó a Segunda RFEF y ahora competirá en Primera RFEF. Eso es evolución, eso es trabajo bien hecho.

"Juan representa los valores que defendemos: compromiso, trabajo y ambición. Verle crecer es una satisfacción enorme," declaró nuestro equipo.

¡Enhorabuena, Juan! A por una gran temporada en Primera RFEF.`
  },
  {
    id: 13,
    title: "Checa, nuevo técnico del UCAM Murcia CF",
    slug: "checa-nuevo-tecnico-ucam-murcia-cf",
    date: "2026-06-04",
    category: "Fichaje",
    image: "/images/news/checa-ucam.jpg",
    summary: "Nuestro entrenador Elite, Checa, es el nuevo técnico del UCAM Murcia CF. Vuelve al club donde ya fue jugador entre 2014 y 2016.",
    content: `Elite Internacional Sport Agency celebra el nombramiento de Checa como nuevo entrenador del UCAM Murcia CF para la temporada 2026/27.

Checa vuelve a casa. El técnico regresa al club donde ya brilló como jugador entre 2014 y 2016, y ahora lo hace para dirigir al equipo desde el banquillo. Una historia de fútbol que cierra un círculo perfecto.

Con su experiencia y conocimiento del club, Checa está preparado para llevar al UCAM Murcia a cumplir los objetivos marcados. Su capacidad de liderazgo, gestión de vestuario y visión táctica serán claves para el proyecto universitario.

"Es un orgullo representar a Checa y verle alcanzar esta oportunidad. Volver a casa siempre es especial, y estamos seguros de que hará una gran temporada," manifestó nuestro equipo.

¡Mucha suerte, míster! A por una temporada histórica.`
  },
  {
    id: 14,
    title: "Alfonso Liceras da el salto a Primera RFEF",
    slug: "alfonso-liceras-salto-primera-rfef",
    date: "2026-06-10",
    category: "Fichaje",
    image: "/images/news/alfonso-extremadura.jpg",
    summary: "Nuestro portero Alfonso Liceras da el salto a Primera RFEF y jugará la 26/27 con el CD Extremadura.",
    content: `Elite Internacional Sport Agency comunica con satisfacción que Alfonso Liceras es nuevo portero del CD Extremadura, equipo que milita en Primera RFEF.

Alfonso, joven guardameta con excelentes reflejos y seguridad bajo palos, da un paso muy importante en su carrera al saltar a la tercera categoría del fútbol español. El CD Extremadura ha apostado por él para defender su portería en la temporada 2026/27.

Este fichaje representa el fruto del trabajo constante de Alfonso y la confianza que ha generado con sus actuaciones. En Elite Internacional siempre hemos creído en su potencial, y ahora tiene la oportunidad de demostrarlo al máximo nivel.

"Alfonso tiene todo lo necesario para triunfar. Es trabajador, humilde y tiene una mentalidad ganadora. Primera RFEF es su sitio," destacó nuestro equipo de representación.

¡Enhorabuena, Alfonso! A defender esa portería con uñas y dientes.`
  },
  {
    id: 15,
    title: "Raúl Hernández vuelve al Rayo Majadahonda CF",
    slug: "raul-hernandez-vuelve-rayo-majadahonda",
    date: "2026-06-13",
    category: "Fichaje",
    image: "/images/news/raul-hernandez-rayo.jpg",
    summary: "Raúl Hernández vuelve a casa. El delantero regresa al Rayo Majadahonda CF para disputar la 26/27 en Primera RFEF junto a Juan Duran.",
    content: `Elite Internacional Sport Agency anuncia que Raúl Hernández es nuevo jugador del Rayo Majadahonda CF para la temporada 2026/27.

Raúl vuelve a casa con muchas ganas y ambición. El delantero veterano se incorpora al proyecto del Rayo Majadahonda para aportar su experiencia y olfato goleador en Primera RFEF. Una categoría exigente que conoce bien y donde está dispuesto a dar lo mejor de sí.

Además, Raúl coincidirá en el vestuario con Juan Duran, también representado por Elite Internacional. Dos de nuestros jugadores compartiendo proyecto es siempre una alegría para nosotros.

"Raúl llega con hambre de goles y éxitos. El Rayo Majadahonda es el lugar perfecto para que demuestre su calidad," comentó nuestro equipo.

¡Bienvenido de nuevo, Raúl! A por una gran temporada junto a Juan.`
  },
  {
    id: 16,
    title: "Álex Macias ficha por el CD Extremadura",
    slug: "alex-macias-ficha-cd-extremadura",
    date: "2026-06-16",
    category: "Fichaje",
    image: "/images/news/alex-macias-extremadura.jpg",
    summary: "Álex Macias se incorpora al CD Extremadura para disputar la temporada 26/27 en Primera RFEF.",
    content: `Elite Internacional Sport Agency comunica que Álex Macias es nuevo jugador del CD Extremadura, club que compite en Primera RFEF.

Álex, lateral izquierdo con gran recorrido y capacidad ofensiva, llega al conjunto extremeño para aportar intensidad y profundidad por la banda. Su fichaje refuerza significativamente las opciones del equipo en el carril zurdo.

El CD Extremadura apuesta por jugadores jóvenes y con hambre de crecer, y Álex encaja perfectamente en ese perfil. Su mentalidad ganadora y capacidad de trabajo serán muy valiosas para el proyecto.

"Álex tiene un potencial enorme. Primera RFEF es una categoría exigente, pero está preparado para dar el nivel," señaló nuestro equipo de representación.

¡Mucha suerte, Álex! A por una temporada memorable.`
  },
  {
    id: 17,
    title: "Charaf refuerza al UCAM Murcia CF",
    slug: "charaf-refuerza-ucam-murcia-cf",
    date: "2026-06-19",
    category: "Fichaje",
    image: "/images/news/charaf-ucam.jpg",
    summary: "Charaf se incorpora al UCAM Murcia CF para aportar goles y desequilibrio en la temporada 26/27.",
    content: `Elite Internacional Sport Agency anuncia que Charaf Taoualy es nuevo jugador del UCAM Murcia CF para la temporada 2026/27.

Charaf llega al conjunto universitario para aportar su calidad, visión de juego y capacidad de llegada. Un centrocampista con gran técnica que será una pieza importante en el esquema del equipo dirigido por Checa, también de la familia Elite.

La coincidencia de Charaf con Checa en el UCAM Murcia es una noticia muy positiva. Dos profesionales de nuestra agencia compartiendo proyecto y trabajando juntos por un objetivo común.

"Charaf tiene talento de sobra para brillar en Segunda RFEF. Su fichaje por el UCAM es una gran noticia," destacó nuestro equipo.

¡A por todas, Charaf! Muchos éxitos en Murcia.`
  },
  {
    id: 18,
    title: "Álvaro Díaz renueva con el CD Estepona",
    slug: "alvaro-diaz-renueva-cd-estepona",
    date: "2026-06-20",
    category: "Renovación",
    image: "/images/news/alvaro-diaz-renueva.jpg",
    summary: "Álvaro Díaz renueva con el CD Estepona para seguir luchando por los objetivos en la temporada 26/27.",
    content: `Elite Internacional Sport Agency comunica la renovación de Álvaro Díaz con el CD Estepona para la temporada 2026/27.

Álvaro, joven defensa con mucha proyección, continuará defendiendo el escudo del Estepona tras una temporada en la que ha demostrado su valía. Su velocidad, agresividad defensiva y capacidad de mejora le convierten en una pieza importante del proyecto.

La renovación es una muestra de confianza del club en Álvaro, y él responde con compromiso y ganas de seguir creciendo. En Elite Internacional celebramos este tipo de noticias, que reflejan el trabajo bien hecho.

"Álvaro tiene mucho futuro por delante. Seguir en el Estepona es la mejor decisión para su desarrollo," comentó nuestro equipo.

¡Enhorabuena, Álvaro! A seguir trabajando y creciendo.`
  },
  {
    id: 19,
    title: "Diego Domínguez renueva con la Balompédica Linense",
    slug: "diego-dominguez-renueva-balompedica-linense",
    date: "2026-06-22",
    category: "Renovación",
    image: "/images/news/diego-linense.jpg",
    summary: "Diego Domínguez continuará defendiendo los colores de la Balompédica Linense en la temporada 26/27.",
    content: `Elite Internacional Sport Agency anuncia la renovación de Diego Domínguez con la Real Balompédica Linense para la temporada 2026/27.

Diego, delantero goleador con gran definición, seguirá aportando sus goles al conjunto linense en Tercera RFEF. Su capacidad de finalización y juego de espaldas son armas muy valiosas que el club ha querido mantener en su plantilla.

La renovación refleja la importancia de Diego en el proyecto del equipo y su compromiso con el escudo. Una noticia positiva para ambas partes.

"Diego es un goleador nato. Su continuidad en La Línea es una gran noticia," destacó nuestro equipo de representación.

¡Muchos goles para la próxima temporada, Diego!`
  },
  {
    id: 20,
    title: "Mario González ficha por la UB Conquense",
    slug: "mario-gonzalez-ficha-ub-conquense",
    date: "2026-06-23",
    category: "Fichaje",
    image: "/images/news/mario-conquense.jpg",
    summary: "Mario González ficha por la UB Conquense. Nuevo escudo pero misma ambición para darlo todo en la 26/27.",
    content: `Elite Internacional Sport Agency comunica que Mario González es nuevo jugador de la UB Conquense para la temporada 2026/27.

Mario, centrocampista box-to-box con gran despliegue físico, llega al conjunto conquense con la ambición de seguir demostrando su calidad en Segunda RFEF. Su capacidad de llegada desde segunda línea y su entrega en cada partido serán muy importantes para el equipo.

Nuevo escudo, pero la misma mentalidad ganadora de siempre. Mario está preparado para competir al máximo y ayudar a la UB Conquense a lograr sus objetivos.

"Mario es un jugador incansable que aporta mucho al equipo. La Conquense ha hecho un gran fichaje," señaló nuestro equipo.

¡A por todas, Mario! Mucha suerte en Cuenca.`
  },
  {
    id: 21,
    title: "Raúl Navas logra el ascenso con el Atlético Central",
    slug: "raul-navas-ascenso-atletico-central",
    date: "2026-06-25",
    category: "Logro",
    image: "/images/news/raul-navas-ascenso.jpg",
    summary: "Raúl Navas consigue ascender con el Atlético Central a 2ª RFEF tras una gran temporada y unos play-offs memorables.",
    content: `¡Hay jugadores que dejan huella donde van, y Raúl Navas es uno de ellos!

Elite Internacional Sport Agency celebra el ascenso del Atlético Central a Segunda RFEF, con nuestro representado Raúl Navas como pieza fundamental del éxito.

Raúl, veterano defensa con una experiencia inigualable, ha sido uno de los pilares del equipo durante toda la temporada. Su liderazgo dentro y fuera del campo, su contundencia defensiva y su capacidad para transmitir calma en los momentos difíciles han sido claves para lograr este histórico ascenso.

Los play-offs fueron una montaña rusa de emociones, pero Raúl y sus compañeros supieron mantener la cabeza fría y certificar el objetivo. Un final de temporada perfecto.

"Raúl es un ejemplo para todos. Su profesionalidad y mentalidad ganadora son admirables. Este ascenso es muy merecido," destacó nuestro equipo.

¡Enhorabuena, Raúl! Eres grande.`
  },
  {
    id: 22,
    title: "Ángel de la Calzada ficha por el CD Cieza",
    slug: "angel-calzada-ficha-cd-cieza",
    date: "2026-06-26",
    category: "Fichaje",
    image: "/images/news/angel-cieza.jpg",
    summary: "Ángel de la Calzada defenderá la portería del CD Cieza en la temporada 26/27 en Segunda RFEF.",
    content: `Elite Internacional Sport Agency comunica que Ángel de la Calzada es nuevo portero del CD Cieza para la temporada 2026/27.

Ángel, guardameta experimentado con seguridad bajo palos y buen juego con los pies, llega al conjunto murciano para defender su portería en Segunda RFEF. Su experiencia y liderazgo desde la portería serán activos muy valiosos para el equipo.

El CD Cieza ha apostado por un portero contrastado que conoce bien la categoría y que aportará fiabilidad al equipo. Una elección acertada que refuerza la parcela más importante del campo.

"Ángel es un portero de garantías. Su fichaje por el Cieza es una gran noticia para ambas partes," comentó nuestro equipo de representación.

¡Mucha suerte, Ángel! A defender esa portería con todo.`
  },
  {
    id: 23,
    title: "Ismael Segura vuelve al Pulpileño",
    slug: "ismael-segura-vuelve-pulpileno",
    date: "2026-06-28",
    category: "Fichaje",
    image: "/images/news/ismael-pulpileno.jpg",
    summary: "Nuestro joven talento Ismael Segura vuelve al Pulpileño para disputar la 26/27 en Tercera RFEF.",
    content: `Elite Internacional Sport Agency comunica que Ismael Segura es nuevo jugador del CF Pulpileño para la temporada 2026/27.

Ismael, joven delantero con velocidad, regate y definición, regresa al Pulpileño para darlo todo nuevamente por el escudo en Tercera RFEF. Una vuelta a casa cargada de ilusión y ganas de demostrar su talento.

Nuestro joven talento Elite tiene mucho potencial por explotar, y el Pulpileño es el lugar perfecto para que siga creciendo y cogiendo experiencia en el fútbol profesional.

"Ismael es un diamante en bruto. Su vuelta al Pulpileño le permitirá seguir desarrollándose y mostrando sus cualidades," destacó nuestro equipo.

¡A por todas, Ismael! Muchos goles para la próxima temporada.`
  },
  {
    id: 24,
    title: "Marcos Alconchel renueva con el Xerez CD",
    slug: "marcos-alconchel-renueva-xerez-cd",
    date: "2026-06-29",
    category: "Renovación",
    image: "/images/news/marcos-alconchel.jpg",
    summary: "El muro de Marcos Alconchel sigue en casa. Nuestro joven portero renueva con el Xerez CD.",
    content: `Elite Internacional Sport Agency celebra la renovación de Marcos Alconchel con el Xerez CD para la temporada 2026/27.

Marcos, joven guardameta con grandes reflejos y capacidad de mejora, continuará defendiendo la portería xerecista en Segunda RFEF. Su trabajo constante y dedicación le han convertido en una pieza importante del proyecto del club.

"El muro de Marcos sigue en casa." Así de claro. El Xerez CD confía en él, y él responde con compromiso y ganas de seguir creciendo bajo los palos.

"Marcos tiene un futuro brillante. Su renovación es el premio al trabajo bien hecho," comentó nuestro equipo de representación.

¡Enhorabuena, Marcos! A seguir trabajando y parando.`
  },
  {
    id: 25,
    title: "Manu Romero renueva con el Sevilla FC C",
    slug: "manu-romero-renueva-sevilla-fc-c",
    date: "2026-07-01",
    category: "Renovación",
    image: "/images/news/manu-romero-sevilla.jpg",
    summary: "Nuestro joven talento Manu Romero renueva con el Sevilla FC C para seguir creciendo en Tercera RFEF.",
    content: `Elite Internacional Sport Agency comunica la renovación de Manu Romero con el Sevilla FC C para la temporada 2026/27.

Manu, centrocampista con talento, visión de juego y capacidad técnica, continuará su formación en el tercer equipo del Sevilla FC en Tercera RFEF. Una decisión acertada para seguir creciendo en una de las mejores canteras de España.

Nuestro joven talento Elite tiene mucho potencial, y el Sevilla FC es el lugar ideal para que siga desarrollándose y dando pasos hacia el fútbol profesional.

"Manu tiene todas las cualidades para llegar lejos. Seguir en la cantera sevillista es lo mejor para su carrera," destacó nuestro equipo.

¡A seguir trabajando y soñando, Manu!`
  },
  {
    id: 26,
    title: "Carlos Toscano amplía su contrato con el Sevilla FC",
    slug: "carlos-toscano-amplia-contrato-sevilla-fc",
    date: "2026-07-03",
    category: "Renovación",
    image: "/images/news/carlos-toscano.jpg",
    summary: "Nuestro joven portero Carlos Toscano sigue en casa y amplía su contrato con el Sevilla FC. Trabajo, constancia y ambición.",
    content: `Elite Internacional Sport Agency celebra la ampliación de contrato de Carlos Toscano con el Sevilla FC.

Carlos, joven portero de la cantera sevillista con grandes reflejos y proyección, ha renovado su vinculación con el club de Nervión. Una muestra de confianza del Sevilla FC en uno de los porteros más prometedores de su cantera.

Trabajo, constancia y ambición. Esas son las claves que han llevado a Carlos hasta aquí, y las que le seguirán impulsando en su camino hacia el fútbol profesional.

"Carlos es un portero con un potencial enorme. El Sevilla FC ha hecho muy bien en apostar por él. Estamos muy orgullosos," manifestó nuestro equipo.

¡Enhorabuena, Carlos! A seguir defendiendo esa portería con orgullo.`
  },
  {
    id: 27,
    title: "Pejiño ficha por el SD Eibar",
    slug: "pejino-ficha-sd-eibar",
    date: "2026-07-04",
    category: "Fichaje",
    image: "/images/news/pejino-eibar.jpg",
    summary: "Pejiño ficha por el SD Eibar para la 26/27 después de seis años en la UD Las Palmas.",
    content: `Elite Internacional Sport Agency anuncia que Pejiño es nuevo jugador del SD Eibar para la temporada 2026/27.

Tras seis temporadas brillantes en la UD Las Palmas, Pejiño cierra un ciclo y abre otro en el País Vasco. El delantero experimentado llega al Eibar con toda la ilusión del mundo para seguir demostrando su calidad en Segunda División.

Pejiño aporta experiencia, goles y capacidad de desequilibrio. Cualidades que el Eibar necesita para pelear por los objetivos de la temporada. Un fichaje de garantías para el conjunto armero.

"Pejiño es un jugador diferencial. Su fichaje por el Eibar es una gran noticia para él y para el club. Estamos muy contentos," destacó nuestro equipo de representación.

¡Mucha suerte en esta nueva etapa, Pejiño! A por grandes cosas en Eibar.`
  },
  {
    id: 28,
    title: "Álvaro Domínguez renueva con el CD Coria",
    slug: "alvaro-dominguez-renueva-cd-coria",
    date: "2026-07-05",
    category: "Renovación",
    image: "/images/news/alvaro-dominguez-coria.jpg",
    summary: "Álvaro Domínguez renueva con el CD Coria tras el ascenso del equipo a Primera RFEF. Elite crece con sus jugadores.",
    content: `Elite Internacional Sport Agency comunica la renovación de Álvaro Domínguez con el CD Coria para la temporada 2026/27.

Álvaro, joven defensa con gran potencial, continuará defendiendo el escudo del Coria después de un histórico ascenso a Primera RFEF. Un premio merecido tras una temporada de trabajo y sacrificio.

Este es otro ejemplo de cómo Elite Internacional crece con sus jugadores. Álvaro llegó a Segunda RFEF y ahora competirá en Primera RFEF. Eso es evolución, eso es hacer las cosas bien.

"Álvaro ha demostrado su valía. Su renovación y el ascenso del Coria son noticias fantásticas. Estamos muy orgullosos," comentó nuestro equipo.

¡Enhorabuena, Álvaro! A disfrutar de Primera RFEF.`
  },
  {
    id: 29,
    title: "Raúl Navas renueva con el Atlético Central",
    slug: "raul-navas-renueva-atletico-central",
    date: "2026-07-06",
    category: "Renovación",
    image: "/images/news/raul-navas-renueva.jpg",
    summary: "Raúl Navas renueva con el Atlético Central para disputar la 26/27 en Segunda RFEF tras el histórico ascenso.",
    content: `Elite Internacional Sport Agency celebra la renovación de Raúl Navas con el Club Atlético Central para la temporada 2026/27.

Raúl, veterano defensa con una experiencia incalculable, continuará aportando su liderazgo, magia y veteranía al equipo en la recién estrenada Segunda RFEF. Tras el histórico ascenso, el club ha querido contar con él para seguir rompiendo límites y alcanzando objetivos.

"Raúl es un referente. Su renovación era fundamental para el proyecto. Estamos encantados de que continúe," destacó nuestro equipo de representación.

¡A seguir haciendo historia, Raúl!`
  },
  {
    id: 30,
    title: "Alfonso Liceras y Álex Macias inician la pretemporada",
    slug: "alfonso-alex-pretemporada-extremadura",
    date: "2026-07-14",
    category: "Actualidad",
    image: "/images/news/alfonso-alex-pretemporada.jpg",
    summary: "Nuestros jugadores Alfonso Liceras y Álex Macias del CD Extremadura ya han empezado la pretemporada. Van con todo para Primera RFEF.",
    content: `Elite Internacional Sport Agency comparte con orgullo las imágenes de Alfonso Liceras y Álex Macias durante el inicio de la pretemporada con el CD Extremadura.

Nuestros dos representados ya están trabajando duro para preparar una temporada ilusionante en Primera RFEF. Portero y lateral izquierdo, dos piezas fundamentales para el equipo que van con todo para lograr los objetivos.

Ver a dos jugadores de la familia Elite compartiendo vestuario y proyecto es siempre una satisfacción. Alfonso y Álex están preparados para dar lo mejor de sí mismos y demostrar su calidad en una categoría tan exigente.

"Alfonso y Álex están muy ilusionados. La pretemporada está siendo intensa, pero están respondiendo a las mil maravillas," comentó nuestro equipo.

¡Mucha suerte a los dos! A por una gran temporada juntos.`
  }
];

export const services = [
  {
    id: 1,
    title: "Representación Deportiva Profesional",
    description: "Gestión integral de la carrera deportiva del futbolista, desde las categorías inferiores hasta el máximo nivel profesional."
  },
  {
    id: 2,
    title: "Negociación y Gestión de Contratos",
    description: "Negociación experta de contratos con clubes nacionales e internacionales, garantizando las mejores condiciones para nuestros representados."
  },
  {
    id: 3,
    title: "Asesoramiento Legal y Financiero",
    description: "Asesoría legal especializada en derecho deportivo y planificación financiera personalizada para asegurar el futuro del jugador."
  },
  {
    id: 4,
    title: "Proyección y Colocación Internacional",
    description: "Red de contactos en las principales ligas europeas y mundiales para facilitar la proyección internacional de nuestros jugadores."
  },
  {
    id: 5,
    title: "Planificación y Desarrollo de Carrera",
    description: "Estrategia personalizada de desarrollo profesional, incluyendo preparación física, nutricional y psicológica."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Carlos M.",
    role: "Jugador Profesional",
    rating: 5,
    comment: "Con Elite Internacional llevo varios años y siempre han estado pendientes de mi carrera. Me ayudaron a tomar buenas decisiones y a encontrar oportunidades que, por mi cuenta, habrían sido muy difíciles. Se nota que conocen bien el mercado."
  },
  {
    id: 2,
    name: "Director Deportivo - Club de LaLiga",
    role: "Club de Primera División",
    rating: 5,
    comment: "Nuestra experiencia con Elite Internacional ha sido muy positiva. La comunicación es fluida, cumplen con los tiempos y los jugadores que representan encajan bien en el perfil que buscamos como club."
  },
  {
    id: 3,
    name: "Miguel R.",
    role: "Jugador Internacional",
    rating: 5,
    comment: "Gracias a Elite Internacional pude dar el paso para jugar fuera de mi país. Me acompañaron durante todo el proceso y me ayudaron con los temas contractuales, lo que me dio mucha tranquilidad."
  }
];

export const whyElite = [
  {
    id: 1,
    title: "Experiencia Contrastada",
    description: "Más de 10 años de experiencia en el sector de la representación deportiva, con presencia en las principales ligas europeas e internacionales."
  },
  {
    id: 2,
    title: "Red Internacional de Contactos",
    description: "Relaciones sólidas con clubes, directores deportivos y ojeadores en Europa."
  },
  {
    id: 3,
    title: "Atención Personalizada",
    description: "Cada jugador es único. Ofrecemos un seguimiento personalizado y constante, adaptándonos a las necesidades específicas de cada carrera."
  },
  {
    id: 4,
    title: "Resultados Contrastados",
    description: "Más de 50 jugadores representados con éxito y transferencias realizadas a clubes de primera división nacional e internacional."
  }
];

export const companyInfo = {
  name: "Elite Internacional Sport Agency",
  address: "Ático A, C. Adolfo Rodríguez Jurado nº 6",
  city: "Casco Antiguo, 41001 Sevilla",
  province: "Provincia de Sevilla",
  email: "juan.varela@elite-internacional.com",
  schedule: "L-V de 9:00 - 17:00",
  rating: 5,
  googleMapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3170.2574886945546!2d-5.996228!3d37.3890924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd126c1d3b3b3b3b%3A0x0!2zMzfCsDIzJzIwLjciTiA1wrA1OSc0Ni40Ilc!5e0!3m2!1ses!2ses!4v1234567890123!5m2!1ses!2ses"
};